import React from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { safeLocaleText } from "../utils/safeLocaleText";
import { Slider } from "primereact/slider";

function getDistanceOptions() {
  const km = safeLocaleText("partnerB2bRadiusKm", "km");
  const options = [];
  for (let i = 0; i <= 250; i += 10) {
    var label = `${i} ${km}`;
    if (i === 0) {
      label = safeLocaleText("all", "All");
    }
    options.push({ label: label, value: i });
  }
  return options;
}

const PartnerB2BSearchBar = ({
  query,
  onQueryChange,
  distance,
  onDistanceChange,
  onSearch,
  loading,
  disabled,
}) => (
  <div className="flex flex-wrap align-items-center gap-2 border-round mb-3">
    <div className="flex-1" style={{ minWidth: "12rem" }}>
      <InputText
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder={safeLocaleText(
          "partnerB2bSearchPlaceholder",
          "ATECO codes or activity areas...",
        )}
        className="w-full border-round-md"
        disabled={disabled}
      />
    </div>

    {/* <Dropdown
      value={distance}
      onChange={(e) => onDistanceChange(e.value)}
      options={getDistanceOptions()}
      optionLabel="label"
      optionValue="value"
      placeholder={safeLocaleText("partnerB2bRadiusLabel", "Radius")}
      className="p-no-outline border-round-md"
      disabled={disabled}
    /> */}
    <Slider
      value={distance}
      onChange={(e) => onDistanceChange(e.value)}
      min={0}
      max={250}
      step={10}
      valueLabelDisplay="on"
      disabled={disabled}
      className="ml-2"
      style={{
        backgroundColor: "var(--theme-border)",
        color: "var(--theme-text)",
        minWidth: "10rem",
      }}
    />

    <span className="text-sm mr-2" style={{ color: "var(--theme-text-muted)" }}>
      {distance} {safeLocaleText("partnerB2bRadiusKm", "km")}
    </span>

    <Button
      label={safeLocaleText("partnerB2bSearch", "Search")}
      icon="pi pi-search"
      onClick={onSearch}
      loading={loading}
      disabled={disabled}
      className="p-button-no-outline border-round-md"
      style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
    />
  </div>
);

export default PartnerB2BSearchBar;
